//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentLinesB', {
//        templateUrl: 'views/components/views/consignmentLinesB/consignmentLinesB.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'consignmentLinesBService', function ($stateParams, stateService, modalService, translateService, consignmentLinesBService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let consignmentLinesBKeyno = $stateParams.consignmentlinesb_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                stockBatchButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockbatchget', { stockbatch_keyno: vm.model.menu.stockbatch_keyno }) }
//                ],
//                menu: {},
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadMenu() {
//                vm.model.menu = (await consignmentLinesBService.getMenu({ consignmentlinesb_keyno: consignmentLinesBKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    consignmentLinesBService.deleteItem(vm.model.menu).then(() => {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE FUNCTION CALL

//            // #region ANGULAR ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadMenu();
//            }

//            // #endregion ANGULAR ON INIT FUNCTION

//        }]
//    });
//})();
